import { observable, action } from 'mobx';
import {
  getDocPlatformList,
  createDocPlatform as createDoc,
  updateDocPlatform,
  deleteDocPlatform,
  releaseDocPlatform,
} from '../server/homeServer';
import {
  PlatfromList,
  CreateDocBody,
  UpdateDocBody,
  DeleteDocBody,
  ReleaseDocBoyd,
} from '../Types';
import { get } from 'lodash';
import errCode from '@/utils/request/errCode';
import i18next from 'i18next';
import Message from '@/component/Message';

class HomeStore {
  // 文档库的列表
  @observable docPlatformList: PlatfromList[] = [];

  // 文档库加载状态
  @observable loadingDocPlatform = true;

  // 刷新列表的标识符
  @observable refreshList = false;

  // 当前分页信息
  @observable pageInfo = {
    page: 1,
    pageSize: 12,
    total: 0,
  };

  @action
  async createDocPlatform(data: CreateDocBody) {
    const { openSceneId } = data;
    const result = await createDoc(data);
    if (result.code === 40109) {
      Message.error(i18next.t('doc_platform_name_exist'));
      return;
    }
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_create_error'));
      return;
    }
    this.fetchDocPlatformList(openSceneId);
  }

  @action
  async updateDocPlatform(data: UpdateDocBody, key: number, changeInfo: UpdateDocBody) {
    const result = await updateDocPlatform(data);
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_update_error'));
      return;
    }
    this.changeDocPlatformList(key, changeInfo);
    Message.success(i18next.t('doc_platform_update_success'));
  }

  @action
  async deleteDocPlatform(data: DeleteDocBody, key: number) {
    const result = await deleteDocPlatform(data);
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_delete_error'));
      return;
    }
    this.deleteDocPlatformList(key);
    Message.success(i18next.t('doc_platform_delete_success'));
  }

  @action
  async releaseDocPlatform(data: ReleaseDocBoyd, key: number, changeInfo: UpdateDocBody) {
    const result = await releaseDocPlatform(data);
    if (result.code !== errCode.SUCCESS) {
      Message.error(i18next.t('doc_platform_release_error'));
      return;
    }
    this.changeDocPlatformList(key, changeInfo);
    Message.success(i18next.t('doc_platform_release_success'));
  }

  @action
  async fetchDocPlatformList(openSceneId: string, page?: number, pageSize?: number) {
    this.loadingDocPlatform = true;
    this.docPlatformList = [];
    const result = await getDocPlatformList({
      openSceneId,
      page: page || this.pageInfo.page,
      pageSize: pageSize || this.pageInfo.pageSize,
    });
    this.loadingDocPlatform = false;
    this.docPlatformList = get(result, 'data.docPlatformList', []);
    this.pageInfo = {
      page: get(result, 'data.pageInfo.page', 1),
      pageSize: get(result, 'data.pageInfo.pageSize', 12),
      total: get(result, 'data.pageInfo.totalNumber', 0),
    };
  }

  @action
  changeDocPlatformList(key: number, changeInfo: UpdateDocBody) {
    const origin = this.docPlatformList[key];
    this.docPlatformList.splice(key, 1, { ...origin, ...changeInfo });
  }

  @action
  deleteDocPlatformList(key: number) {
    this.docPlatformList.splice(key, 1);
  }
}
export default { name: 'homeStore', Store: HomeStore };
